import PropTypes from 'prop-types';

/** A Slack integration object */
export default PropTypes.shape({
  teamName: PropTypes.string.isRequired,
  webhookChannel: PropTypes.string.isRequired,
  webhookChannelId: PropTypes.string.isRequired,
  webhookConfigurationUrl: PropTypes.string.isRequired,
});
